// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2iOR9I","iconContainer":"Hmx2OD","icon":"QzoJ3P","preTitle":"_1P6YY5"};